import { useEffect } from 'react';
import { useAuth } from '../lib/auth';
import { completeDashboardAuthAttempt } from '../lib/dashboardAuthTelemetry';

export function useDashboardAuthTelemetry(): void {
  const { isLoaded, isSignedIn, sessionId } = useAuth() as ReturnType<typeof useAuth> & { sessionId?: string | null };
  useEffect(() => {
    if (isLoaded && isSignedIn && sessionId) completeDashboardAuthAttempt(sessionId);
  }, [isLoaded, isSignedIn, sessionId]);
}
